import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-origin",
  "use": "icon-ic-origin-usage",
  "viewBox": "0 0 21 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 20\" id=\"icon-ic-origin\"><rect x=\".5\" width=\"20\" height=\"20\" rx=\"2\" fill=\"#fff\" /><rect x=\"1.5\" y=\"1\" width=\"18\" height=\"18\" rx=\"1\" stroke=\"#000\" stroke-width=\"2\" /><circle cx=\"10.5\" cy=\"10\" r=\"5\" fill=\"#000\" /><circle cx=\"10.5\" cy=\"10\" r=\"2\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol